import { Suspense } from 'react';
// components
import LoadingScreen from '../components/loading-screen';
import { lazyLoad } from '../utils/lazyLoad';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const LoginPage = Loadable(lazyLoad(() => import('../pages/auth/LoginPage')));

// DASHBOARD: GENERAL
export const GeneralAppPage = Loadable(lazyLoad(() => import('../pages/dashboard/GeneralAppPage')));
export const GeneralEcommercePage = Loadable(
  lazyLoad(() => import('../pages/dashboard/GeneralEcommercePage'))
);

export const GeneralAnalyticsPage = Loadable(
  lazyLoad(() => import('../pages/dashboard/GeneralAnalyticsPage'))
);

export const GeneralWithdrawPage = Loadable(
  lazyLoad(() => import('../pages/dashboard/GeneralWithdrawPage'))
);
export const GeneralPartnersPage = Loadable(
  lazyLoad(() => import('../pages/dashboard/GeneralPartnersPage'))
);
export const PartnerPage = Loadable(
  lazyLoad(() => import('../pages/dashboard/PartnerPage'))
);

// DASHBOARD: ECOMMERCE
export const EcommerceShopPage = Loadable(
  lazyLoad(() => import('../pages/dashboard/EcommerceShopPage'))
);

// MAIN
export const Page404 = Loadable(lazyLoad(() => import('../pages/Page404')));
export { default as NetworkError } from '../pages/NetworkError'
